import React from 'react';
import SearchTable from './SearchTable.js';
import Popup from './Popup.js';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary.js';
import db from './db.js';
var tableColumnRender = require("./TableColumnRender.js")
var tae = require("./TableAddEdit.js");
var functions = require("./functions.js");

// OrderAllTable component
export default class OrderAllTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.orderAllTableRef = React.createRef();
        let cols=[];
        try{
            cols.push({ key: 'organization_name', title:"Parent Company", noedit:true });
            cols.push({ key: 'display_facility_name', title:"Facility Name", noedit:true });
            cols.push({ key: 'source', title:"source", width:50, noedit:true } );
            cols.push({ key: 'source_order_no', title : "Source Order No.", width :20, noedit:true});
            cols.push({ key: 'order_created_date', title:"Created", width:30, noedit:true} );  
            cols.push({ key: 'info',  title:"Info", width :40, noedit:true });
            cols.push({ key: 'facility_id', title:"Facility Id", width :40, noedit:true, noquery:true, doNotDisplayInTable:true });
            cols.push({ key: 'source_order_id', title:"Order Id", width :40, noedit:true, noquery:true, doNotDisplayInTable:true });
            cols.push({ key: 'source_customer_id', title:"Customer Id", width :40, noedit:true, noquery:true, doNotDisplayInTable:true });
        } catch (ex){}        
        this.state={
            selectedObject:false,
            columns:cols,
            line_items:[]
        };

    }
    componentDidMount(prevProps) {
        if(this.props.facility_id){
            this.orderAllTableRef.current.queryData();
        }  

    }    
    // render
    render() {
        let qry=this.props.securityObject.httpServer+"api/get/orderAll?";  
        if(this.props.facility_id){
            qry+=`facility_id=${this.props.facility_id}`;
            
        }
        return (true)?(
            <div className='relative-div'>
                <SearchTable
                    query={qry}
                    columns={this.state.columns}
                    securityObject={this.props.securityObject}
                    tableHeight="70vh"
                    key="tableAddEditTableAddEdit"
                    onClick={this.showEditScreen.bind(this)}
                    ref={this.orderAllTableRef}
                    hideSearch={this.props.hideSearch}
                >
                </SearchTable>
                 <Popup trigger={this.state.selectedObject}>
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>                     
                    <table>
                        <tr>
                            <td class="plain"  width="500px">
                                {tae.getEditScreen(
                                    this.state.columns
                                    , this.state.selectedObject
                                    ) 
                                }
                                <button onClick={() => functions.openOrder(this.state.selectedObject.source, this.state.selectedObject.source_order_id) }>Order</button>
                                <button onClick={() => functions.openCustomer(this.state.selectedObject.source, this.state.selectedObject.source_customer_id) }>Customer</button>
                                
                            </td >
                            <td class="plain">
                            <TableScrollbar  height="50vh">
                                <ErrorBoundary>
                                    <Table columns={[
                                        { key: 'name', title:"Item", width :10,render:tableColumnRender.renderMultiLineText } 
                                        ,{ key: 'item_style', title:"Style", width :10,render:tableColumnRender.renderMultiLineText } 
                                        , { key: 'sku', Info:"SKU", width :20 }
                                        , { key: 'additional_info', Info:"Host Name", width :20,render:tableColumnRender.renderMultiLineText }
                                        , { key: 'quantity', title:"Quantity", width :20 }
                                    ]} 
                                    dataSource={this.state.line_items} 
                                    />
                                </ErrorBoundary>
                            </TableScrollbar>                        

                            </td>
                        </tr>
                    </table>
                </Popup>               
            </div>
        ):"";
    }

  
    showEditScreen(rowData){
        let qry=this.props.securityObject.httpServer+'api/get/orderAllDetail?source_order_id='+rowData.source_order_id;
        db.getSearchPopupData( 
            qry
            ,this.props.securityObject
            ,(list) => { 
                this.setState({
                    line_items: list
                })
            }
        )
        
        this.setState({
            selectedObject:rowData
        })
    }
    // close the popup
    closePopup(){
        this.setState({
            selectedObject:false
        });
    }    
    

}

